import React from "react";

export const CHAT_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 4H21C21.2652 4 21.5196 4.10536 21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18H2V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4Z"
      fill="#3077EB"
    />
    <path
      opacity="0.35"
      d="M2 21.1V18H9L3.6 21.9C3.45143 22.0114 3.27477 22.0793 3.08981 22.096C2.90484 22.1126 2.71889 22.0775 2.55279 21.9944C2.38668 21.9114 2.24698 21.7837 2.14935 21.6257C2.05171 21.4678 2 21.2857 2 21.1Z"
      fill="#3077EB"
    />
  </svg>
);

export const PHONE_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 2H7C6.74235 2.02253 6.50088 2.13512 6.318 2.318C6.13512 2.50088 6.02253 2.74235 6 3V21C6.02253 21.2576 6.13512 21.4991 6.318 21.682C6.50088 21.8649 6.74235 21.9775 7 22H17C17.2576 21.9775 17.4991 21.8649 17.682 21.682C17.8649 21.4991 17.9775 21.2576 18 21V3C17.9775 2.74235 17.8649 2.50088 17.682 2.318C17.4991 2.13512 17.2576 2.02253 17 2ZM12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19C12.2652 19 12.5196 19.1054 12.7071 19.2929C12.8946 19.4804 13 19.7348 13 20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z"
      fill="#3077EB"
    />
    <path
      opacity="0.25"
      d="M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z"
      fill="#3077EB"
    />
  </svg>
);

export const MAP_MARKER_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.35"
      d="M21 20H17C16.4477 20 16 20.4477 16 21C16 21.5523 16.4477 22 17 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20Z"
      fill="#3077EB"
    />
    <path
      opacity="0.35"
      d="M7 20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H7C7.55228 22 8 21.5523 8 21C8 20.4477 7.55228 20 7 20Z"
      fill="#3077EB"
    />
    <path
      d="M12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 14.4 10 22 12 22C14 22 20 14.4 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2ZM12 12C11.6044 12 11.2178 11.8827 10.8889 11.6629C10.56 11.4432 10.3036 11.1308 10.1522 10.7654C10.0009 10.3999 9.96126 9.99778 10.0384 9.60982C10.1156 9.22186 10.3061 8.86549 10.5858 8.58579C10.8655 8.30608 11.2219 8.1156 11.6098 8.03843C11.9978 7.96126 12.3999 8.00087 12.7654 8.15224C13.1308 8.30362 13.4432 8.55996 13.6629 8.88886C13.8827 9.21776 14 9.60444 14 10C14 10.5304 13.7893 11.0391 13.4142 11.4142C13.0391 11.7893 12.5304 12 12 12Z"
      fill="#3077EB"
    />
    <path
      opacity="0.35"
      d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
      fill="#3077EB"
    />
  </svg>
);

export const NOTES_DUOTONE_ICONS = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.35"
      d="M14.2853 3.38382L3.00903 7.48806C2.49005 7.67695 2.22246 8.25079 2.41136 8.76977L6.5156 20.0461C6.70449 20.5651 7.27833 20.8326 7.79731 20.6438L19.0736 16.5395C19.5926 16.3506 19.8602 15.7768 19.6713 15.2578L15.5671 3.98149C15.3782 3.46251 14.8043 3.19492 14.2853 3.38382Z"
      fill="#3077EB"
    />
    <path
      d="M20 5H8C7.44772 5 7 5.44772 7 6V18C7 18.5523 7.44772 19 8 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z"
      fill="#3077EB"
    />
  </svg>
);

export const CHECKLIST_DUOTONE_ICONS = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H11C10.4477 4 10 4.44772 10 5V7C10 7.55228 10.4477 8 11 8H20C20.5523 8 21 7.55228 21 7V5C21 4.44772 20.5523 4 20 4Z"
      fill="#686572"
    />
    <path
      opacity="0.25"
      d="M20 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H20C20.5523 14 21 13.5523 21 13V11C21 10.4477 20.5523 10 20 10Z"
      fill="#686572"
    />
    <path
      opacity="0.25"
      d="M20 16H11C10.4477 16 10 16.4477 10 17V19C10 19.5523 10.4477 20 11 20H20C20.5523 20 21 19.5523 21 19V17C21 16.4477 20.5523 16 20 16Z"
      fill="#686572"
    />
    <path
      opacity="0.25"
      d="M6 10H4C3.44772 10 3 10.4477 3 11V13C3 13.5523 3.44772 14 4 14H6C6.55228 14 7 13.5523 7 13V11C7 10.4477 6.55228 10 6 10Z"
      fill="#686572"
    />
    <path
      d="M6 4H4C3.44772 4 3 4.44772 3 5V7C3 7.55228 3.44772 8 4 8H6C6.55228 8 7 7.55228 7 7V5C7 4.44772 6.55228 4 6 4Z"
      fill="#686572"
    />
    <path
      opacity="0.25"
      d="M6 16H4C3.44772 16 3 16.4477 3 17V19C3 19.5523 3.44772 20 4 20H6C6.55228 20 7 19.5523 7 19V17C7 16.4477 6.55228 16 6 16Z"
      fill="#686572"
    />
  </svg>
);

export const GRAPH_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.15"
      d="M21 2H3C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2Z"
      fill="#686572"
    />
    <path
      d="M2.00001 21V16C6.00001 16 7.00001 10 10 10C13 10 13 13 16 13C19 13 19 4 22 4V21C22.0161 21.1352 22.0013 21.2723 21.9567 21.4009C21.9122 21.5296 21.839 21.6464 21.7427 21.7427C21.6464 21.839 21.5296 21.9121 21.4009 21.9567C21.2723 22.0013 21.1352 22.0161 21 22H3.00001C2.86482 22.0161 2.72774 22.0013 2.59909 21.9567C2.47045 21.9121 2.35359 21.839 2.25732 21.7427C2.16105 21.6464 2.08787 21.5296 2.0433 21.4009C1.99873 21.2723 1.98393 21.1352 2.00001 21Z"
      fill="#686572"
    />
  </svg>
);

export const FIRE_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.9 13.8C20.7427 14.4314 20.4338 15.015 20 15.5C19.367 16.1799 18.5774 16.6949 17.7 17C16.7054 17.3459 15.6425 17.4487 14.6 17.3C13.547 17.1259 12.5711 16.6379 11.8 15.9C10.9273 15.0264 10.3354 13.9121 10.1 12.7C9.97935 11.9726 9.9125 11.2372 9.9 10.5V9.49999C9.8492 9.1686 9.8492 8.83139 9.9 8.49999V8.69999C9.6 11.2 8.2 11.3 7.6 10.1C7 8.89999 7 7.09999 8 4.89999C6.50006 5.65697 5.23897 6.81442 4.35645 8.2441C3.47393 9.67378 3.00444 11.3199 3 13C2.99899 14.5803 3.41411 16.133 4.20361 17.502C4.99311 18.871 6.12916 20.008 7.4975 20.7986C8.86585 21.5891 10.4182 22.0055 11.9986 22.0058C13.5789 22.006 15.1314 21.5902 16.5 20.8C17.8017 19.9976 18.8976 18.9017 19.7 17.6C20.5366 16.247 20.9862 14.6906 21 13.1C21 13.3 20.9 13.5 20.9 13.8Z"
      fill="#686572"
    />
    <path
      opacity="0.15"
      d="M17 4C17.7306 4.93817 18.0869 6.11411 18 7.3C17 5 12 5 13 2C13 2 10.2 3.4 9.90003 8.5C9.71271 10.2163 9.88295 11.9528 10.4 13.6C10.6988 14.5621 11.2515 15.4258 12 16.1C12.7688 16.735 13.6932 17.1532 14.6777 17.3114C15.6621 17.4696 16.671 17.3621 17.6 17C18.5621 16.7012 19.4258 16.1485 20.1 15.4C20.7059 14.6714 21.0259 13.7472 21 12.8C20.9831 11.9966 20.9163 11.1951 20.8 10.4C20.5257 8.77254 19.8751 7.23163 18.9 5.9C18.3973 5.14828 17.7518 4.50271 17 4Z"
      fill="#686572"
    />
  </svg>
);

export const HEART_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.15"
      d="M11.2 20.2H11.4C9.62522 18.0691 8.70411 15.3556 8.81495 12.5846C8.92579 9.81364 10.0607 7.18233 12 5.2L11.5 4.7C10.9947 4.15795 10.3833 3.72569 9.70371 3.43013C9.02415 3.13458 8.29104 2.98206 7.55 2.98206C6.80896 2.98206 6.07584 3.13458 5.39629 3.43013C4.71674 3.72569 4.10529 4.15795 3.6 4.7C2.59503 5.78966 2.03705 7.21767 2.03705 8.7C2.03705 10.1823 2.59503 11.6104 3.6 12.7L11 20L11.2 20.2Z"
      fill="#686572"
    />
    <path
      d="M20 4.30001C18.8876 3.40289 17.4787 2.9564 16.0526 3.04901C14.6264 3.14161 13.2871 3.76656 12.3 4.80001L12 5.20001C10.052 7.16796 8.8943 9.7827 8.74682 12.5478C8.59935 15.313 9.47232 18.036 11.2 20.2C11.4075 20.411 11.6856 20.5379 11.9809 20.5564C12.2762 20.5748 12.5679 20.4835 12.8 20.3L20.4 12.7C20.9439 12.1317 21.3664 11.4586 21.642 10.7218C21.9176 9.98505 22.0404 9.1999 22.003 8.41416C21.9656 7.62841 21.7687 6.85849 21.4244 6.15121C21.08 5.44394 20.5954 4.8141 20 4.30001Z"
      fill="#686572"
    />
  </svg>
);

export const HAPPY_DUOTONE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z"
      fill="#686572"
    />
    <path
      d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
      fill="#E8E8EA"
    />
    <path
      d="M16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11Z"
      fill="#E8E8EA"
    />
    <path
      d="M14.3 15.2C13.6456 15.7186 12.835 16.0005 12 16C11.5984 16.0209 11.1967 15.9609 10.8188 15.8235C10.4408 15.686 10.0944 15.474 9.80003 15.2C9.60937 14.9961 9.34831 14.8724 9.06978 14.8538C8.79125 14.8352 8.51608 14.9232 8.30003 15.1C8.12291 15.2852 8.01599 15.5264 7.99773 15.782C7.97947 16.0376 8.05103 16.2915 8.20003 16.5C8.7027 16.989 9.29741 17.3734 9.9497 17.6309C10.602 17.8883 11.2989 18.0138 12 18C12.7012 18.0138 13.3981 17.8883 14.0504 17.6309C14.7027 17.3734 15.2974 16.989 15.8 16.5C15.949 16.2915 16.0206 16.0376 16.0023 15.782C15.9841 15.5264 15.8772 15.2852 15.7 15.1C15.5003 14.9295 15.2415 14.8444 14.9795 14.8631C14.7176 14.8818 14.4735 15.0028 14.3 15.2Z"
      fill="#E8E8EA"
    />
  </svg>
);
